import React from 'react';
import KickImage from 'Reuseables/KickImage';
import classNames from 'classnames';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Container,
  FormGroup,
  Button,
} from 'reactstrap';
import CloseIcon from '../../images/close-button-search.png';
import ImageSeller from '../../images/location1024.png';
import { InputSelect } from '../Forms/Input';

// const disabledButton = props => {
//   if (props.value === null || props.value === props.sellerLocation) {
//     return true
//   } else {
//     return false
//   }
// };

type Props = {
  countryLocation: string;
  sellerLocation: number;
  isOpen: boolean;
  onToggle: () => any;
  countryName: string;
  onChangeCountry: (selected: any) => any;
  countryValue: { value: string; label: string } | string | null;
  countryOptions: { value: string; label: string }[];
  name: string;
  onChange: (selected: any) => any;
  value: { value: number; label: string } | number | null;
  options: { value: number; label: string }[];
  onClick: () => any;
  isSubmitted: boolean;
  errorProvince: null | string;
  errorCountry: null | string;
};

const ModalSellerLocationV3 = (props: Props) => {
  return (
    <Modal
      className="kick-modal seller-location"
      isOpen={props.isOpen}
      toggle={props.onToggle}
    >
      <Container id="payment">
        <ModalBody>
          <div className="close-modal" onClick={props.onToggle}>
            <KickImage src={CloseIcon} alt="close-icon" />
          </div>
          <div className="image-modal">
            <KickImage src={ImageSeller} alt={'image-seller'} />
          </div>
          {props.isSubmitted ? (
            <div className="text-info">
              <p>Your location is confirmed!</p>
              <p>Thank you for your response.</p>
            </div>
          ) : (
            <div>
              <div className="text-info">
                <p>Please confirm your location.</p>
                <p>
                  Your location is needed for us to calculate the shipping time.
                </p>
              </div>
              <div className="input-form">
                <FormGroup>
                  <InputSelect
                    className="input-select"
                    name={props.countryName}
                    onChange={props.onChangeCountry}
                    value={props.countryValue}
                    options={props.countryOptions}
                    placeholder={''}
                  />
                  {props.errorCountry ? (
                    <div className="invalid-feedback-form">
                      <p>{props.errorCountry}</p>
                    </div>
                  ) : null}
                </FormGroup>
              </div>
              <div className="input-form">
                <FormGroup>
                  <InputSelect
                    className="input-select"
                    name={props.name}
                    onChange={props.onChange}
                    value={props.value}
                    options={props.options}
                    placeholder={''}
                  />
                  {props.errorProvince ? (
                    <div className="invalid-feedback-form">
                      <p>{props.errorProvince}</p>
                    </div>
                  ) : null}
                </FormGroup>
              </div>
              <div className="submit-button">
                <Button
                  className={classNames('submit-province', {
                    'btn-green':
                      props.value !== null ||
                      props.value !== props.sellerLocation,
                  })}
                  disabled={
                    (props.countryValue === null && props.value === null) ||
                    props.value === null ||
                    (props.countryValue === props.countryLocation &&
                      props.value === props.sellerLocation) ||
                    props.value === props.sellerLocation
                  }
                  onClick={props.onClick}
                >
                  Confirm Location
                </Button>
              </div>
            </div>
          )}
        </ModalBody>
      </Container>
    </Modal>
  );
};

export default ModalSellerLocationV3;
